@let o = overview();
@let u = ui();

<section
  class="hd-circuits-overview-info"
  [class.hd-circuits-overview-info--floating]="isFloating"
>
  <header class="hd-circuits-overview-info__header">
    <h3 class="hd-circuits-overview-info__title">{{ o.title }}</h3>
    @if (o.subtitle) {
      <p class="hd-circuits-overview-info__subtitle">{{ o.subtitle }}</p>
    }
  </header>

  <hd-circuit-info-kernwoorden
    [label]="u.kernwoordenLabel"
    [items]="o.kernwoorden"
  />

  <markdown
    class="hd-circuits-overview-info__body"
    [src]="markdownSrc()"
  ></markdown>
</section>
